import React, { Component } from 'react'
import logo from '../../../static/images/activelamp-logo-white.svg'
import PolysSVG from '../PolysSVG'
import { renderToStaticMarkup } from 'react-dom/server'
import './Hero.scss'
import { Link } from 'gatsby'

const Hero = ({postType, heroType, alignLeft, children, heroTreatment, scroll}) => {
  const svgString = encodeURIComponent(renderToStaticMarkup(<PolysSVG />))
  const dataUri = `url("data:image/svg+xml,${svgString}")`
  return (
    <div className={'hero-wrapper ' + 'hero-wrapper-' + postType}>
      <div className="hero"></div>
      <div
        className={heroType ? heroType : 'landing-left'}
        style={{ backgroundImage: dataUri, backgroundSize: 'cover' }}
      >
        <div className="hero-container">
          <div className="logo-img">
            <Link to="/" rel="home" title="Home">
              <img
                src={logo}
                alt="ActiveLAMP Logo"
                title="ActiveLAMP Logo"
                id="logo"
                data-scroll-alt={logo}
              />
            </Link>
          </div>
          <div
            className={`hero-callout ${
              alignLeft ? 'align-left' : ''
            }`}
          >
            {children}
          </div>
        </div>
      </div>
      {heroTreatment}
      {scroll}
    </div>
  )
}

export default Hero
